import { VideoTrack } from "@livekit/components-react";
import type { TrackReference } from "@livekit/components-core";

export function AvatarVideo({
  trackRef,
  onClose,
}: {
  trackRef: TrackReference;
  onClose: () => void;
}) {
  return (
    <div className="lk-widget-avatar-video">
      <VideoTrack trackRef={trackRef} />
      <button
        className="lk-widget-avatar-video-close"
        onClick={onClose}
        aria-label="Hide video"
      >
        &#x2715;
      </button>
    </div>
  );
}
